






























































































































































































import Vue from 'vue'
import ToggleList, {
  ToggleListItem,
} from '@/components/globals/basics/ToggleList.vue'
import Loading from '@/components/globals/basics/Loading/Loading.vue'
import PageDefaultLayout from '@/components/globals/PageDefaultLayout.vue'
import ProgramCard from '@/components/program/ProgramCard.vue'
import TimetableCard from '@/components/program/TimetableCard.vue'
import ProgramPagination from '@/components/program/ProgramPagination.vue'
import * as Sentry from '@sentry/browser'
import showErrorDialog from '@/tools/error-dialog'
import {
  listProgram,
  ProgramWithTimetables,
  PagerMeta as ProgramsPagerMeta,
  ViewMode,
} from '@/core/Programs'
import {
  listTimetable,
  ListTimetableItem,
  PagerMeta as TimetablesPagerMeta,
} from '@/core/Timetables'
import {
  verifyAuthEmail,
  hasVerifyEmailQuery,
  isVerifiedUser,
  castVerifyEmailParams,
} from '@/core/Auth'
import { Meta } from '@/tools/page'
import { Keys } from '@/store/modules/search/getters'
import { buildProgramPath, Facility } from '@/core/Facilities'

const PAGE_TITLE = 'プログラム一覧'
const PAGE_META: Meta[] = [
  {
    name: 'description',
    content:
      'GYYMで利用できるフィットネスジムのプログラムです。今話題のジムや人気のプログラムを見つけて気軽にフィットネスを始めましょう！',
  },
]

const programSortItems: ToggleListItem[] = [
  {
    label: '新着順',
    value: {
      sortBy: 'createdAt',
      order: 'desc',
    },
  },
  {
    label: '価格順',
    value: {
      sortBy: 'minTimetablePoint',
      order: 'asc',
    },
  },
  {
    label: '日付順',
    value: {
      sortBy: 'minTimetableStartAt',
      order: 'asc',
    },
  },
]

const timetableSortItems: ToggleListItem[] = [
  {
    label: '日付順',
    value: {
      sortBy: 'start_at',
      order: 'asc',
    },
  },
  {
    label: '価格順',
    value: {
      sortBy: 'point',
      order: 'asc',
    },
  },
]

export default Vue.extend({
  components: {
    ToggleList,
    PageDefaultLayout,
    ProgramCard,
    TimetableCard,
    ProgramPagination,
    Loading,
  },
  data() {
    return {
      ViewMode,
      viewMode: ViewMode.PROGRAMS,
      isFetchingPrograms: false,
      isFetchingTimetables: false,
      programSortItems,
      timetableSortItems,
      currentSortValue: { ...programSortItems[0].value },
      showSimpleModal: false,
      programs: [] as ProgramWithTimetables[],
      timetables: [] as ListTimetableItem[],
      programsMeta: {} as ProgramsPagerMeta,
      timetablesMeta: {} as TimetablesPagerMeta,
    }
  },
  computed: {
    hasSearchQuery(): boolean {
      //@ts-ignore
      const {
        activityIds,
        areaIds,
        sexLimitation,
        level,
        startTimeBefore,
        startTimeAfter,
        searchDates,
        showFullReservations,
      } = this.$route.query

      return (
        (!!activityIds && activityIds.length !== 0) ||
        (!!areaIds && areaIds.length !== 0) ||
        (!!sexLimitation && sexLimitation.length !== 0) ||
        (!!level && level.length !== 0) ||
        !!startTimeBefore ||
        !!startTimeAfter ||
        (!!searchDates && searchDates.length !== 0) ||
        // $router.pushでクエリを渡すとboolean型/URLからクエリを取得していた場合はstring型になる
        (showFullReservations !== undefined &&
          `${showFullReservations}` === 'false')
      )
    },
    title(): string {
      return this.hasSearchQuery ? '検索結果' : 'すべてのプログラム'
    },
  },
  watch: {
    $route: 'fetchData',
  },
  created() {
    this.$setPageTitle(PAGE_TITLE)
    this.$setPageMeta(PAGE_META)

    if (hasVerifyEmailQuery(this.$route.query)) {
      this.verifyEmail()
    }

    this.fetchData()
  },
  methods: {
    changeViewMode(mode: ViewMode) {
      this.viewMode = mode

      // ソートをviewModeに応じて切り替える
      switch (mode) {
        case ViewMode.TIMETABLES:
          this.currentSortValue = { ...timetableSortItems[0].value }
          break
        case ViewMode.PROGRAMS:
        default:
          this.currentSortValue = { ...programSortItems[0].value }
      }

      // データを取得
      this.fetchData()
    },
    buildProgramPath(facility: Facility, program: ProgramWithTimetables) {
      return buildProgramPath(facility, program)
    },
    handleSortChange(value: ToggleListItem) {
      this.currentSortValue = value
      this.$router
        .push({
          path: this.$route.path,
          query: { ...this.$route.query, page: undefined },
        })
        .catch(() => {
          // 同一パスの場合はNavigationDuplicatedになるため、watchからではなくこちらからfetchする
          this.fetchData()
        })
    },
    async verifyEmail(): Promise<void> {
      if (!this.$store.getters['auth/isLogin']) {
        this.$router.push({ path: '/login', query: this.$route.query })
        return
      }

      if (!isVerifiedUser()) {
        try {
          await verifyAuthEmail(castVerifyEmailParams(this.$route.query as any))
        } catch (error) {
          Sentry.captureException(error)
          showErrorDialog({ msg: 'メール認証を再度行ってください' })
          return
        }
      }

      if (!this.$store.getters['auth/user'].name) {
        this.$modal.push('ProfileModal')

        // 立て続けに$modal.pushすると↑のProfileModalのイベントが発火されなくなるのでタイマーで少し遅延させる
        setTimeout(() => {
          this.$modal.push('CompleteRegisterModal', true)
        }, 50)
      }
    },
    async fetchData() {
      switch (this.viewMode) {
        case ViewMode.TIMETABLES:
          this.fetchTimetablesData()
          break
        case ViewMode.PROGRAMS:
        default:
          this.fetchProgramsData()
      }
    },
    async fetchProgramsData() {
      this.isFetchingPrograms = true

      const { startTimeBefore, startTimeAfter, ...conditions } =
        this.$store.getters[Keys.GET_SEARCH_CONDITIONS]

      const { data: programs, meta } = await listProgram({
        ...conditions,
        // 空文字列などはundefined扱いにする
        startTimeBefore: startTimeBefore ? startTimeBefore : undefined,
        startTimeAfter: startTimeAfter ? startTimeAfter : undefined,
        ...this.currentSortValue,
        page: this.$route.query.page || 1,
      })

      this.programs = programs
      this.programsMeta = meta
      this.isFetchingPrograms = false
    },
    async fetchTimetablesData() {
      this.isFetchingTimetables = true

      const { startTimeBefore, startTimeAfter, ...conditions } =
        this.$store.getters[Keys.GET_SEARCH_CONDITIONS]

      const { data: timetables, meta } = await listTimetable({
        ...conditions,
        // 空文字列などはundefined扱いにする
        startTimeBefore: startTimeBefore ? startTimeBefore : undefined,
        startTimeAfter: startTimeAfter ? startTimeAfter : undefined,
        ...this.currentSortValue,
        page: this.$route.query.page || 1,
      })

      this.timetables = timetables
      this.timetablesMeta = meta
      this.isFetchingTimetables = false
    },
    closeSimpleModal() {
      this.showSimpleModal = false
    },
  },
})
